/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const NoteIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M5.25 7.5H8.75C8.8875 7.5 9 7.6125 9 7.75V8.25C9 8.3875 8.8875 8.5 8.75 8.5H5.25C5.1125 8.5 5 8.3875 5 8.25V7.75C5 7.6125 5.1125 7.5 5.25 7.5ZM5.25 10.5H8.75C8.8875 10.5 9 10.6125 9 10.75V11.25C9 11.3875 8.8875 11.5 8.75 11.5H5.25C5.1125 11.5 5 11.3875 5 11.25V10.75C5 10.6125 5.1125 10.5 5.25 10.5ZM10.5 7.25C10.9156 7.25 11.25 7.58437 11.25 8C11.25 8.41562 10.9156 8.75 10.5 8.75C10.0844 8.75 9.75 8.41562 9.75 8C9.75 7.58437 10.0844 7.25 10.5 7.25ZM10.5 10.25C10.9156 10.25 11.25 10.5844 11.25 11C11.25 11.4156 10.9156 11.75 10.5 11.75C10.0844 11.75 9.75 11.4156 9.75 11C9.75 10.5844 10.0844 10.25 10.5 10.25ZM3.5 2H6.26875C6.25625 1.91875 6.25 1.83438 6.25 1.75C6.25 0.784375 7.03438 0 8 0C8.96562 0 9.75 0.784375 9.75 1.75C9.75 1.83438 9.74375 1.91875 9.73125 2H12.5C13.3281 2 14 2.67188 14 3.5V14.5C14 15.3281 13.3281 16 12.5 16H3.5C2.67188 16 2 15.3281 2 14.5V3.5C2 2.67188 2.67188 2 3.5 2ZM8 1C7.58437 1 7.25 1.33438 7.25 1.75C7.25 2.16563 7.58437 2.5 8 2.5C8.41563 2.5 8.75 2.16563 8.75 1.75C8.75 1.33438 8.41563 1 8 1ZM3 14.5C3 14.775 3.225 15 3.5 15H12.5C12.775 15 13 14.775 13 14.5V3.5C13 3.225 12.775 3 12.5 3H11V3.625C11 3.83125 10.8312 4 10.625 4H5.375C5.16875 4 5 3.83125 5 3.625V3H3.5C3.225 3 3 3.225 3 3.5V14.5Z"
        fill={color}
      />
    </svg>
  );
};
